import type TableView from "../store/schema/TableView";

/**
 * Returns whether the user's selection covers more than one message: either
 * several items, or at least one collapsed group header.
 *
 * This is the counterpart of `isSingleItemSelection`; neither returns true for
 * an empty selection.
 *
 * @param tableView the table view
 */
export default function isMultipleSelection(tableView: TableView): boolean {
    return tableView.selectedGroupHeaders.size > 0 || tableView.selectedRowKeys.size > 1;
}
